<template>
  <div class="mt-3">
    <div class="align-exportable">
      <slot name="before"></slot>
      <div class="px-3" v-if="isPDF()">
        <button class="btn btn-danger custom-shadow-btn" @click="exportToPDF">
          <em class="fa fa-file-pdf-o"></em>
          {{ getLabelPDF }}
        </button>
      </div>
      <div class="px-3" v-if="isExcel()">
        <button
          class="btn custom-btn-success custom-shadow-btn"
          @click="exportToExcel"
        >
          <em class="fa fa-file-excel-o"></em>
          {{ getLabelXLS }}
        </button>
      </div>
      <slot name="after"></slot>
    </div>
  </div>
</template>

<script>
import MixinPermissions from 'src/util/mixinPermissions';
import { MixinExport } from 'src/mixins/mixin-export';
import { MixinNotification } from 'src/mixins/mixin-notification';
import SweetAlert from 'src/class/Alerts';
import i18n from '../../i18n';

export default {
  name: 'export-tables',
  mixins: [MixinPermissions, MixinExport, MixinNotification],
  props: {
    pdf: {
      type: Object,
      default: () => {
        return {
          filename: 'test_pdf',
          route: '/',
          paramMethod: 'GET',
          plusData: {},
        };
      },
    },
    xls: {
      type: Object,
      default: () => {
        return {
          filename: 'test_excel',
          route: '/',
          paramMethod: 'GET',
          plusData: {},
        };
      },
    },
    labelExportPDF: {
      type: String,
      default: null,
    },
    labelExportExcel: {
      type: String,
      default: null,
    },
  },
  computed: {
    getLabelPDF() {
      return this.labelExportPDF
        ? this.labelExportPDF
        : i18n.t('common_words.export_to_pdf');
    },
    getLabelXLS() {
      return this.labelExportExcel
        ? this.labelExportExcel
        : i18n.t('common_words.export_to_excel');
    },
  },
  methods: {
    showDownloadNotification() {
      this.showNotification(
        i18n.t('comp.tab.export_tables.file_downloaded_successfully'),
        'success',
        'nc-cloud-download-93',
        i18n.t('comp.tab.export_tables.download_complete')
      );
    },

    showMessageErrors(error) {
      console.log(error);
      let msg = `${i18n.t('common_words.ups')}<br/><br/>`;
      if (error.response && error.response.data && error.response.data.errors) {
        let i = 1;
        for (var key in error.response.data.errors) {
          msg += `${i++}. ${error.response.data.errors[key]} <br/>`;
        }
      } else {
        if (error.response) {
          if (error.response.data && error.response.data.message) {
            msg = error.response.data.message;
          } else {
            if (error.response.data.errorcode) {
              msg = error.response.data.error;
            } else {
              msg = i18n.t('comp.tab.export_tables.error_sending_information');
            }
          }
        } else {
          msg =
            i18n.t('comp.tab.export_tables.error_sending_information') +
            (error ? '"' + error + '"' : '');
        }
      }

      SweetAlert.danger(msg);
    },

    exportToPDF() {
      let data = {};
      data.route = this.pdf.route;
      data.name_file = this.pdf.filename;

      if (this.pdf.paramMethod === 'POST')
        data = { ...data, ...this.pdf.plusData };

      this.PDF(data, this.pdf.paramMethod, this.pdf.paramMethod === 'POST')
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    exportToExcel() {
      let data = {};
      data.route = this.xls.route;
      data.name_file = this.xls.filename;

      if (this.pdf.paramMethod === 'POST')
        data = { ...data, ...this.pdf.plusData };

      this.Excel(data, this.pdf.paramMethod, this.pdf.paramMethod === 'POST')
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },
  },
};
</script>
<style>
.align-exportable {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
}
</style>
